import {useSearchParams} from "react-router-dom";
import {useEffect, useLayoutEffect, useState} from "react";
import q_api from "../api/public/questionnaire";

import QuestionnaireAccess from "../components/questionnare/QuestionnaireAccess";
import QuestionnaireEntry from "../components/questionnare/QuestionnaireEntry";
import QuestionnaireResponses from "../components/questionnare/QuestionnaireResponses";
import QuestionnaireComplete from "../components/questionnare/QuestionnaireComplete";

// Mobile browsers move a still-focused control back into view after the next
// pillar renders, and scroll anchoring can keep the viewport on the buttons.
const scrollSurveyToTop = () => {
    const active = document.activeElement;
    if (active && active !== document.body && typeof active.blur === "function") {
        active.blur();
    }
    const scroller = document.scrollingElement || document.documentElement;
    scroller.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);
};

const Questionnaire = () => {
    const [params] = useSearchParams()
    const uuid = params.get("v");
    const [validAccessKey, setValidAccessKey] = useState(false);
    const [accessKey, setAccessKey] = useState();
    const [questions, setQuestions] = useState();
    const [pillarName, setPillarName] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [showEntryPage, setShowEntryPage] = useState(false);
    const [showResponsesPage, setShowResponsesPage] = useState(false);
    const [showCompletedPage, setShowCompletedPage] = useState(false);
    const [surveyType, setSurveyType] = useState(1);
    const [surveyPoint, setSurveyPoint] = useState(0);
    const [coachSubscription, setCoachSubscription] = useState(0)

    useLayoutEffect(() => {
        if (!showResponsesPage) return;
        scrollSurveyToTop();
    }, [showResponsesPage, currentPage, questions]);

    useEffect(() => {
        if (!showResponsesPage) return;
        scrollSurveyToTop();
        const frame = requestAnimationFrame(scrollSurveyToTop);
        const timer = window.setTimeout(scrollSurveyToTop, 60);
        return () => {
            cancelAnimationFrame(frame);
            clearTimeout(timer);
        };
    }, [showResponsesPage, currentPage, questions]);

    const updateKey = (key) => {
        setAccessKey(key);
        setValidAccessKey(true);
        setShowEntryPage(true);
    }

    const updateQuestions = (questions) => {
        setQuestions(questions)
    }

    const updatePillarName = (name) => {
        setPillarName(name);
    }

    const updateEntry = () => {
        setShowEntryPage(false);
        setShowResponsesPage(true);
    }

    const handleNextPage = (responses) => {
        if (currentPage > 6) return;
        let body = {
            "responses": responses
        }
        let response = q_api.updateResponses(uuid, accessKey, currentPage, body);
        response.then(() => {
            if (currentPage === 6) {
                setShowResponsesPage(false);
                setShowCompletedPage(true);
            } else {
                const next = currentPage + 1;
                setCurrentPage(next);
                let r = q_api.getQuestions(uuid, accessKey, next);
                r.then(r => {
                    updateQuestions(r.data.responses);
                    setPillarName(r.data.pillar.name);
                }).catch(err => {
                    console.log(err);
                })
            }
        }).catch(err => console.log(err))
    }

    const handleSaveProgress = (responses) => {
        if (!responses) return;
        let body = {
            "responses": responses
        }
        let response = q_api.updateResponses(uuid, accessKey, currentPage, body);
        response.then(() => {

        }).catch(err => console.log(err))
    }

    const handlePrevPage = (responses) => {
        if (currentPage === 1) return;

        let body = {
            "responses": responses
        }
        let response = q_api.updateResponses(uuid, accessKey, currentPage, body);
        response.then(() => {
            const next = currentPage - 1;
            setCurrentPage(next);
            let r = q_api.getQuestions(uuid, accessKey, next);
            r.then(r => {
                updateQuestions(r.data.responses);
                setPillarName(r.data.pillar.name);
            }).catch(err => console.log(err))
        }).catch(err => console.log(err))
    }

    return (
        !validAccessKey ?
            <QuestionnaireAccess uuid={uuid} updateKey={updateKey.bind(this)}
                                 updateQuestions={updateQuestions.bind(this)}
                                 updatePillarName={updatePillarName.bind(this)}
                                 updateSurveyType={setSurveyType.bind(this)}
                                 updateSurveyPoint={setSurveyPoint.bind(this)}
                                 updateCoachSubscription={setCoachSubscription.bind(this)}
            />
            :
            <>
                {showEntryPage ?
                    <QuestionnaireEntry updateEntry={updateEntry.bind(this)} surveyType={surveyType}/>
                    : null
                }
                {showResponsesPage ?
                    <QuestionnaireResponses questions={questions} handleNext={handleNextPage.bind(this)}
                                            handlePrev={handlePrevPage.bind(this)}
                                            handleSave={handleSaveProgress.bind(this)}
                                            page={currentPage} pillarName={pillarName}
                    />
                    : null
                }
                {showCompletedPage ?
                    <QuestionnaireComplete surveyPoint={surveyPoint} uuid={uuid}
                                           accessKey={accessKey} coachSubscription={coachSubscription}/>
                    : null
                }
            </>
    )
}

export default Questionnaire